import React from 'react';

import { ZipAutocomplete, ZipAutocompleteProps } from '@common/react/components/Forms/ZipAutocomplete/ZipAutocomplete';
import FormikField, { FormikFieldProps } from '@common/react/components/Forms/FormikField/FormikField';

interface Props extends Omit<FormikFieldProps, 'render' | 'children' | 'fieldName'> {
	fieldName?: string;
	transformValues?: (item: { zip, city, state }) => any;
	zipAutocompleteProps?: ZipAutocompleteProps['other'];
}

const FormFieldZipAutocomplete: React.FC<Props> = (props) => {
	const {
		transformValues = (item) => item,
		zipAutocompleteProps,
		...rest
	} = props;
	return <FormikField
		title="Zip"
		fieldName="zip"
		{...rest}
	>
		{(fieldProps) => (
			<ZipAutocomplete
				{...zipAutocompleteProps}
				onSelect={(value, option) => {
					const item = {
						zip: option.props.item.zip,
						city: option.props.item.city,
						state: option.props.item.stateName,
					};
					fieldProps.form.setValues((prev) => ({
						...prev,
						...transformValues(item),
					}));
				}}
				onChange={(value) => {
					!value && fieldProps.form.setFieldValue('zip', '');
				}}
				fieldProps={fieldProps}
				other={{ antdProps: { id: 'zip' } }}
			/>
		)}
	</FormikField>;
};

export default FormFieldZipAutocomplete;
